import { useEffect } from 'react'
import { LoginForm } from '@/components/LoginForm'
import { CircularProgress } from '@mui/material'
import { Redirect, Route, Switch } from 'wouter'
import App from './App'
import Mobile from './pages/UserApp/Mobile.jsx'
import { useUser } from './pb'

export default function Router() {
  const { user } = useUser()

  useEffect(() => {
    if (user === null && window.location.pathname !== '/') {
      window.history.replaceState(null, '', '/')
    }
  }, [user])

  if (user === undefined) {
    return (
      <span className="centered-fixed">
        <CircularProgress color="secondary" size="500px" />
      </span>
    )
  }

  if (user === null) {
    return <LoginForm />
  }

  const hasPrivilegedRole =
    user.role?.includes('admin') || user.role?.includes('trainer')

  return (
    <Switch>
      <Route path="/">
        <Redirect to={hasPrivilegedRole ? '/admin/music' : '/app'} />
      </Route>

      <Route path="/admin">
        <Redirect to={hasPrivilegedRole ? '/admin/music' : '/app'} />
      </Route>

      <Route path="/admin" nest>
        <Route path="/:page">
          {({ page }) =>
            hasPrivilegedRole ? <App currentPage={page} /> : <Redirect to="/app" />
          }
        </Route>
      </Route>

      <Mobile />

      <Route>404: No such page!</Route>
    </Switch>
  )
}